{
	"config": {
		"missing_entities": "Please specify entities",
		"missing_names": "Please specify names",
		"missing_command_topic": "Please specify command_topic"
	},
	"common": {
		"description": "A card to edit the programmes of a windhager heater",
		"missing_entities": "No entities defined",
		"entity_unavailable": "{entity} is not available.",
		"programme": "Programme",
		"apply": "Apply"
	},
	"weekdays": {
		"Mo": "Mo",
		"Tu": "Tu",
		"We": "We",
		"Th": "Th",
		"Fr": "Fr",
		"Sa": "Sa",
		"Su": "Su"
	}
}
